module.exports = __webpack_public_path__ + "la.0175af4ad2836f38e130.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/la.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/la.svg
// module chunks = styles